import { DBColumn } from "./DBColumn";

export class MFGDBColumn {
  public constructor() {
    this.CustomText = "";
    this.DBColumnRowPointer = "";
    this.DBColumnName = "";
    this.DefaultUOM = "";
    this.DBTable = "";
    this.SortOrder = 0;
    this.UnitDisplay = "";
    this.DefaultValue = "";
    this.FeedbackCode = "";
    this.DBColumn = new DBColumn();
  }

  public CustomText: string;
  public DBColumnName: string;
  public DBColumnRowPointer: string;
  public DefaultUOM: string;
  public DBTable: string;
  public SortOrder: number;
  public UnitDisplay: string;
  public DefaultValue: string;
  public FeedbackCode: string;
  public DBColumn: DBColumn;
}
